import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "../../api";
import swal from "sweetalert";

const SearchPage = () => {
 const [params] = useSearchParams();
 const [results, setResults] = useState([]);
 const [loading, setLoading] = useState(true);

 const query = params.get("query") || "";

 const loadResults = async () => {
 try {
 setLoading(true);

 if (!query) {
 swal("Oops!", "Search keyword is missing.", "warning");
 setLoading(false);
 return;
 }

 const res = await api.get(`/vendor-categories?search=${query}`);

 setResults(res.data?.data || []);
 setLoading(false);
 } catch (error) {
 console.log("Search Error:", error);
 setLoading(false);
 }
 };

 useEffect(() => {
 loadResults();
 }, [query]);

 return (
 <div className="container mt-4">

 <h3 className="mb-3">
 Search results for: <b>"{query}"</b>
 </h3>

 {loading && <p>Loading...</p>}

 {!loading && results.length === 0 && (
 <p className="text-danger">No results found.</p>
 )}

 {results.map((item) => (
 <div className="p-3 border rounded mb-2" key={item._id}>
 <h5>{item.name}</h5>
 <p>{item.description}</p>
 </div>
 ))}
 </div>
 );
};

export default SearchPage;
